import { render, staticRenderFns } from "./Mark.vue?vue&type=template&id=270761d9&scoped=true&"
import script from "./Mark.vue?vue&type=script&lang=js&"
export * from "./Mark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270761d9",
  null
  
)

export default component.exports